import script from "./MobileLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileLogin.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/mobile/login.css?vue&type=style&index=0&id=1a1cd80f&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a1cd80f"]])

export default __exports__